module.exports = __webpack_public_path__ + "static/genesis_noir-2a7844c5d892490b94edad795e52fb04.png";